import { FilterFieldGroup } from '@App/forms/common/filter-field-group'
import { FormFieldTypes } from '@App/enum/form-field-types'
import { MatchedRecordingsFilterType } from '@App/forms/filters/rightsholder-catalog-filter'

export interface ClaimSearchFilter {
    notClaimedByFilter?: NotClaimedByFilterType
    matchedRecordingsFilter?: MatchedRecordingsFilterType[]
}

export type NotClaimedByFilterType = Record<'notClaimedBy', boolean>

export const claimSearchFilterGroup: FilterFieldGroup<ClaimSearchFilter> = {
    name: 'Claim Search Filters',
    allowMultiple: false,
    filterFields: [
        {
            notClaimedByFilter: {
                name: 'notClaimedByFilter',
                label: 'Include works claimed by my Member',
                type: FormFieldTypes.CHECKBOX,
                checked: false,
            },
        },
    ],
}

export const claimMatchedRecordingFilterGroup: FilterFieldGroup<ClaimSearchFilter> = {
    name: 'Matched Recordings Filter',
    allowMultiple: false,
    filterFields: [
        {
            matchedRecordingsFilter: {
                name: 'matchedRecordingsFilter',
                label: '',
                type: FormFieldTypes.RADIO,
                options: [
                    {
                        name: '',
                        label: 'All Works',
                        default: true,
                    },
                    {
                        name: 'has_matched_recordings',
                        label: 'Only works with matched recordings',
                    },
                    {
                        name: 'has_no_matched_recordings',
                        label: 'Only works with no matched recordings',
                    },
                ],
            },
        },
    ],
}

export const ClaimSearchFilterCollection: Array<FilterFieldGroup<ClaimSearchFilter>> = [
    claimSearchFilterGroup,
    claimMatchedRecordingFilterGroup,
]
